const frontendDomain = (import.meta as any).env?.VITE_FRONTEND_DOMAIN ?? "https://sociuslegal.com";

export const nonProtectedRoutes = {
  HOME: `${frontendDomain}/`,
  LOGIN: "/login/",
  CONTACT: `${frontendDomain}/contact-us`,
  LOGOUT: "/logout/",
  PRICING: `${frontendDomain}/pricing`,
  CORPORATE_FIRMS: "/corporate-firms/",
  MERGE_ACQUISITIONS: "/mergers-acquisitions/",
  EC_VC: "/ec-vc/",
  SECURITY: "/security/",
  RESPONSIBLE_AI: "/responsible-ai/",
  REGISTER: "/register/",
  TERMS: `${frontendDomain}/terms`,
  ACTIVATE: "/activate/:token/",
  NOT_FOUND: "/not-found/",
};

export const protectedRoutes = {
  CHECKOUT: "checkout",
  DASHBOARD: "/app/dashboard/",
  PAYMENT_SUCCESS: "checkout/success/",
  PAYMENT_CANCEL: "checkout/cancel/",
  TENANT_ADMIN: "tenant/",
  PROFILE: "profile/",
};

export default nonProtectedRoutes;
